// @flow

import {findDeepestVehiclePath, isVehicleKeyAncestor} from "../helper/vehicleKey";

/**
 * Resolves the currently filtered vehicle to an ordered list of display-name segments
 * (top series down to the most specific selected node). Returns [] when no vehicle filter
 * is active. The labels are matched case-insensitively against the fitment tree so the
 * selected branch can be auto-expanded and highlighted (ticket #53422).
 *
 * Mirrors the resolution used in CarSelectionBarContainer so both views agree on which
 * node is "selected".
 */
export const selectFilterVehiclePath = (state: any): string[] => {
    const filter = state && state.filter;
    if (!filter) return [];

    const filterObject = filter.filter || {};
    const filterStatsSeries = (filter.filterStats && filter.filterStats.vehicleSeries) || [];
    const brand = state.content && state.content.brand;
    const brandSeries = (brand && brand.vehicleSeries) || [];

    const directKeys = [filterObject.vehicle, filterObject.vehicleModel].filter(Boolean);
    if (directKeys.length === 0 && !filterObject.vehicleKey) return [];

    const matchesSelection = vehicle => !!vehicle && (
        directKeys.some(key => vehicle.key === key || vehicle.name === key || vehicle.title === key)
        || isVehicleKeyAncestor(filterObject.vehicleKey, vehicle.key)
    );

    let breadcrumbPath = findDeepestVehiclePath(filterStatsSeries, matchesSelection);
    if (breadcrumbPath.length === 0 ||
        (filterObject.vehicleKey && breadcrumbPath[breadcrumbPath.length - 1].key !== filterObject.vehicleKey)) {
        const brandPath = findDeepestVehiclePath(brandSeries, matchesSelection);
        if (brandPath.length > breadcrumbPath.length) {
            breadcrumbPath = brandPath;
        }
    }

    return breadcrumbPath
        .map(node => (node && (node.title || node.name)) || "")
        .filter(Boolean);
};
